<template>
    <section>
        <!--工具条-->
        <el-col :span="24" class="toolbar">
            <el-form :inline="true" class="demo-form-inline" align="left">
                <el-form-item>
                    <el-button icon="document" @click.native.prevent="addUpdateInfoUI" :loading="addLoading">添加版本信息</el-button>
                </el-form-item>
            </el-form>
        </el-col>
        <!--列表-->
        <template>
            <el-table :data="tableJsonData" highlight-current-row v-loading="listLoading" style="width: 100%;" stripe @row-click="handleEditUI">
                <el-table-column prop="type" label="版本时间" width="200">
                </el-table-column>
                <el-table-column prop="title" label="版本号" width="100">
                </el-table-column>
                <el-table-column prop="content" label="更新内容" width="400">
                </el-table-column>
                <el-table-column prop="Action" label="操作" width="200" >
                    <template slot-scope="scope">
                        <el-button @click="handleEditUI(scope.row)" v-show="seen()" type="primary" size="mini" style="width: auto" icon="el-icon-edit"></el-button>
                        <el-button @click="deleteUserSubmit(scope.row)" v-show="seen()" type="danger" size="mini" icon="el-icon-delete" style="width: auto"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </template>
        <!--编辑界面-->
        <el-dialog :title="editFormTtile" v-model="editFormVisible" :visible.sync="editFormVisible"  :close-on-click-modal="false">
            <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm" align="left">
                <el-form-item label="版本日期：" prop="versionDate">
                    <el-date-picker v-model="editForm.versionDate" type="datetime" placeholder="选择版本日期时间" :picker-options="pickerOptions">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="版本号：" prop="versionNum">
                    <el-input v-model="editForm.versionNum" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="更新信息：" prop="updateInfo">
                    <el-input type="textarea" :rows="9" placeholder="请输入内容" v-model="editForm.updateInfo"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click.native="editFormVisible = false">取 消</el-button>
                <el-button type="primary" @click.native="modifySubmit" :loading="editLoading">{{btnEditText}}</el-button>
            </div>
        </el-dialog>
    </section>
</template>

<script>
    import { Config } from '@/config/config'
    //import NProgress from 'nprogress'
    import {
        mapState
    } from 'vuex'
    import Notify from '../../api/notifyMsg'

    export default {
        computed: mapState({
            user: state => state.user
        }),
        data() {
            var validateUpdateDate = (rule, value, callback) => {
                console.log(value)
                if (value === '') {
                    callback(new Error('请选择日期！'));
                } else {
                    callback();
                }
            };
            return {
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    }
                },
                // versionDate: new Date(),
                editFormVisible: false, //修改界面显是否显示
                editFormTtile: '修改', //修改界面标题
                //修改界面数据
                editForm: {
                    Id: '',
                    versionDate: '',
                    updateInfo: '',
                    versionNum: ''
                },
                sedEmailValue: false,
                editLoading: false,
                btnEditText: '提 交',
                editFormRules: {
                    versionDate: [{
                        required: true,
                        validator: validateUpdateDate,
                        trigger: 'blur'
                    }],
                    updateInfo: [{
                        required: true,
                        message: '请输入更新信息！',
                        trigger: 'blur'
                    }],
                    versionNum: [{
                        required: true,
                        message: '请输入版本号！',
                        trigger: 'blur'
                    }],
                },
                //tableJsonData: [{content:["123", "23415"], createtime: 1521184495000, endtime: 0, id: "20",title: "V1.1.1",type: "about",userId: "U1002"}],
                tableJsonData: [],
                listLoading: false,
                addLoading: false,
                isUpdateInfo: false,
                apiUrl: "/api/v1/console/versioninfo",
            }
        },
        methods: {
            seen() {
                if(this.user.Role !== "admin") {
                    return false;
                } else {
                    return true;
                }
            },
            getUpdateInfoData() {
                var _this = this

                var url = Config.url + _this.apiUrl
                var data = {
                    params: {
                        type: "about",
                        token: _this.user.token
                    }
                }

                _this.$http.get(url, data)
                    .then((response) => {

                        if (response.data.Error_code === 1000) {
                            //if (response.data.Dept_json === null) return
                            _this.formatTime(response.data.messages)
                        } else {
                            Notify.errMsgNotify(response.data.Error_code, this)
                            return
                        }
                    })
                    .catch(function(response) {
                        Notify.catchMsgNotify(this)
                        console.log(response)
                    })
            },
            formatTime(data) {
                var dataLen = data.length
                for (let i = 0; i < dataLen; i++) {
                    let newDate = new Date();
                    newDate.setTime(data[i].createtime );
                    data[i].type = newDate.toLocaleString()
                }

                this.tableJsonData = data
            },
            sendToEmail(id) {
                var _this = this
                //return
                /*_this.$http.post(APIHOST + "/api/v1/manager/message/" + id, {
                    params: {
                        token: _this.user.token
                    }
                })
                    .then((response) => {

                        if (response.data.Error_code === 1000) {
                            _this.$notify({
                                title: '邮件推送成功',
                                message: '邮件推送成功！',
                                type: 'success'
                            });
                        } else {
                            Notify.errMsgNotify(response.data.Error_code, this)
                            return
                        }
                    })
                    .catch(function(response) {
                        Notify.catchMsgNotify(this)
                        console.log(response)
                    })*/

            },
            addUpdateInfo(FromData) {
                var _this = this

                _this.$http.post(Config.url + _this.apiUrl + '?token=' + _this.user.token + '&push=' + _this.sedEmailValue, {
                    createtime: Date.parse(new Date(FromData.versionDate)),
                    title: FromData.versionNum,
                    content: FromData.updateInfo,
                    userid: _this.user.UID,
                    type: 'about'
                })
                    .then((response) => {
                        console.log(response.data.Error_code)
                        if (response.data.Error_code === 1000) {
                            _this.$notify({
                                title: '添加成功',
                                message: '添加成功！',
                                type: 'success'
                            });

                            _this.getUpdateInfoData() //重新获取数据
                        } else {
                            Notify.errMsgNotify(response.data.Error_code, this)
                            return
                        }
                    })
                    .catch(function(response) {
                        Notify.catchMsgNotify(this)
                        console.log(response)
                    })
            },
            modifyUpdateInfo(FromData) {
                var _this = this

                _this.$http.put(Config.url + _this.apiUrl + '?token=' + _this.user.token + '&push=' + _this.sedEmailValue, {
                    id: FromData.Id,
                    createtime:  Date.parse(new Date(FromData.versionDate)),
                    title: FromData.versionNum,
                    content: FromData.updateInfo,
                    userId: _this.user.UID,
                    type: 'about'
                })
                    .then((response) => {
                        console.log(response.data.Error_code)
                        if (response.data.Error_code === 1000) {
                            _this.$notify({
                                title: '修改成功',
                                message: '修改成功！',
                                type: 'success'
                            });
                            _this.getUpdateInfoData() //重新获取数据
                        } else {
                            Notify.errMsgNotify(response.data.Error_code, this)
                            return
                        }
                    })
                    .catch(function(response) {
                        Notify.catchMsgNotify(this)
                        console.log(response)
                    })
            },
            GMTToStr(time) {
                let date = new Date(time)
                let Str = date.getFullYear() + '/' +
                    (date.getMonth() + 1) + '/' +
                    date.getDate() + ' ' +
                    date.getHours() + ':' +
                    date.getMinutes() + ':' +
                    date.getSeconds()
                return Str
            },
            Detele(ID) {
                var _this = this

                _this.$http.delete(Config.url + _this.apiUrl, {
                    params: {
                        token: _this.user.token,
                        id: ID
                    }
                })
                    .then((response) => {

                        console.log("Detele ：" + response.data.Error_code)

                        if (response.data.Error_code === 1000) {
                            _this.$notify({
                                title: '删除成功',
                                message: '删除成功！',
                                type: 'success'
                            });
                            _this.getUpdateInfoData() //重新获取数据
                        } else {
                            Notify.errMsgNotify(response.data.Error_code, this)
                            return
                        }
                    })
                    .catch(function(response) {
                        Notify.catchMsgNotify(this)
                        console.log(response)
                    })
            },
            //删除记录
            deleteUserSubmit: function(row) {
                //console.log(row);
                var _this = this;
                _this.$confirm('确认删除该记录吗?', '提示', {
                    //type: 'warning'
                }).then(() => {
                    _this.listLoading = true;
                    //NProgress.start();
                    _this.Detele(row.id)
                    console.log(row.id)
                    setTimeout(function() {
                        //NProgress.done();
                        _this.listLoading = false;
                    }, 1000);
                }).catch(() => {

                });
            },
            addUpdateInfoUI: function(row) {
                var _this = this
                if (!_this.seen()) {
                    _this.$message({
                        type: 'fail',
                        message: '没有操作权限！'
                    });
                    return
                }

                _this.editFormTtile = '添加版本更新信息';
                // _this.editForm = {}
                _this.editForm.Id = ''
                _this.editForm.versionDate = new Date()
                _this.editForm.updateInfo = ''
                _this.editForm.versionNum = ''
                _this.sedEmailValue = false

                _this.isUpdateInfo = false

                _this.editFormVisible = true;
            },
            //显示修改界面
            handleEditUI: function(row, event, column) {
                var _this = this
                if (column !== undefined && column.property === "Action") {
                    return;
                }

                if (!_this.seen()) {
                    _this.$message({
                        type: 'fail',
                        message: '没有操作权限！'
                    });
                    return
                }

                _this.editFormTtile = '修改版本更新信息';
                console.log("handleEditUI ", row, row.createtime, new Date(row.createtime));
                _this.editForm.Id = row.id;
                _this.editForm.versionDate = new Date(row.createtime);
                _this.editForm.versionNum = row.title;

                _this.editForm.updateInfo = row.content;
                _this.sedEmailValue = false;


                _this.isUpdateInfo = true;

                _this.editFormVisible = true;
            },
            //修改
            modifySubmit: function() {
                var _this = this;
                _this.$refs.editForm.validate((valid) => {
                    if (valid) {
                        _this.$confirm('确认提交吗？', '提示', {}).then(() => {
                            _this.editLoading = true;
                            //NProgress.start();
                            _this.btnEditText = '提交中';

                            if (_this.isUpdateInfo === true) {
                                _this.modifyUpdateInfo(_this.editForm);
                            } else {
                                _this.addUpdateInfo(_this.editForm);
                            }

                            setTimeout(function() {
                                _this.editLoading = false;
                                //NProgress.done();
                                _this.btnEditText = '提 交';
                                _this.editFormVisible = false;
                            }, 1000);
                        });
                    }
                });
            }
        },
        created: function() {
            this.getUpdateInfoData();
        },
        watch: {
            sedEmailValue: function(val, oldVal) {
                //console.log('new: %s, old: %s', val, oldVal)
                if (val === true) {
                    this.$confirm('慎用功能！必须征得两个系统管理员同意方可使用，确认邮件方式推送给全部用户？', '警告', {
                        type: 'warning'
                    }).then(() => {

                    }).catch(() => {
                        this.sedEmailValue = false
                    });
                }
            },
        }
    }
</script>
<style scoped>
    .toolbar {
        background: #fff;
        /*padding: 10px 10px 0px 10px;*/
    }
</style>


// WEBPACK FOOTER //
// src/components/data/Version.vue